// extracted by mini-css-extract-plugin
module.exports = {"types":"students-form_types__2kgYR"};